import styled from 'styled-components';

export const StyledOption = styled.div`
  width: 100%;
  text-align: center;

  .title {
    font-weight: 500;

    & + .field {
      margin-top: 5px;
    }
  }

  &.current {
    .title {
      color: ${props => props.theme.colors.primary};
    }
  }

  & + & {
    margin-top: 10px;
  }
`

export const StyledIcon = styled.div`
  height: 50px;
  text-align: center;
  margin-bottom: 15px;

  img {
    height: 100%;
  }
`
